import type { Transport } from "@connectrpc/connect";
import { createBrandTransport, fetchBrand, loadBrand, setMemberBrand } from "@fox1ck-org/auth/saas";

import { runtimeConfig } from "@/lib/runtime-config";

/** This service on console's brand answer: its name under the organisation's. */
export const PRODUCT = { id: "app-manager", name: "App Manager" } as const;

/** A slow console means the neutral page, never a blank one. */
const WAIT_MS = 1500;

/** GetBrand by org names the organisation; `product` adds the lockup's second line. The kit's lookup has no way to pass it. */
function forProduct(inner: Transport): Transport {
  return {
    ...inner,
    unary: (method, signal, timeoutMs, header, input, context) => {
      (input as { product?: string }).product = PRODUCT.id;
      return inner.unary(method, signal, timeoutMs, header, input, context);
    },
  };
}

/**
 * The lockup before the first frame. Realm vibe: the token has no org claim,
 * so the organisation is the runtime config's `orgId`, and the names come from
 * console, never from a word in the product.
 */
export async function loadPageBrand(): Promise<void> {
  const { consoleUrl, extra } = runtimeConfig;
  if (!consoleUrl) return;
  const orgId = typeof extra.orgId === "string" ? extra.orgId : "";
  const asked = Promise.all([
    loadBrand({ consoleUrl }).catch(() => null),
    orgId
      ? fetchBrand(forProduct(createBrandTransport(consoleUrl)), { orgId })
          .then(setMemberBrand)
          .catch(() => null)
      : null,
  ]);
  await Promise.race([asked, new Promise((done) => setTimeout(done, WAIT_MS))]);
}
